import React, { useState } from "react";
import "./Flow.css";
import CardWrapper from "../../shared/CardWrapper/CardWrapper";
import FlowTable from "./FlowTable";
import ReportFlowTag from "../../shared/ReportFlowTag/ReportFlowTag";
import BarChart from "../../dashboard/BarChart";
import {
  getWaterFlowProductionX08Query,
  getWaterFlowDistributionX04Query,
} from "../../util/query";
import { generateClient } from "aws-amplify/api";
import { getPlantId } from "../../util/helper";

export default function Flow() {
  const plantId = getPlantId();
  const client = generateClient();
  const [selectedFilter, setSelectedFilter] = useState("Day");
  const [tab, setTab] = useState("tab1");
  const [flowWaterProduction, setFlowWaterProduction] = useState();
  const [flowWaterDistribution, setFlowWaterDistribution] = useState();
  async function fetchFlowWaterProduction() {
    try {
      const query = getWaterFlowProductionX08Query(
        selectedFilter.toLowerCase(),
        plantId
      );
      // Make the asynchronous GraphQL request
      const flowIn = await client.graphql({ query });
      if (flowIn) {
        setFlowWaterProduction(flowIn.data.getWaterFlowProductionX08);
      }
      console.log({ flowIn });
    } catch (error) {
      console.error("Error fetching flow in production data:", error);
    }
  }

  async function fetchFlowWaterDistribution() {
    try {
      const query = getWaterFlowDistributionX04Query(
        selectedFilter.toLowerCase(),
        plantId
      );
      // Make the asynchronous GraphQL request
      const flowOut = await client.graphql({ query });
      if (flowOut) {
        setFlowWaterDistribution(flowOut.data.getWaterFlowDistributionX04);
      }
      console.log({ flowOut });
    } catch (error) {
      console.error("Error fetching flow in production data:", error);
    }
  }
  React.useEffect(() => {
    const fetchData = () => {
      if (tab === "tab1") {
        fetchFlowWaterProduction();
      }
      if (tab === "tab2") {
        fetchFlowWaterDistribution();
      }
    };
    fetchData(); // Initial fetch
    const interval = setInterval(fetchData, 600000); // Set interval to 10 minutes
    return () => clearInterval(interval);
  }, [tab, selectedFilter]);
  React.useEffect(() => {
    setFlowWaterProduction();
    setFlowWaterDistribution();
  }, [tab, selectedFilter]);

  const toFixedOrDash = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed.toFixed(2) : "--";
  };

  const getCurrentValue = (tab) => {
    if (flowWaterProduction && tab === "tab1") {
      return toFixedOrDash(flowWaterProduction.current_flowLpmin_x08);
    }

    if (flowWaterDistribution && tab === "tab2") {
      return toFixedOrDash(flowWaterDistribution.current_flowLpmin_x04);
    }
  };

  const getRecentValue = (tab) => {
    if (flowWaterProduction && tab === "tab1") {
      return toFixedOrDash(flowWaterProduction.flow_totilizer_x08);
    }
    if (flowWaterDistribution && tab === "tab2") {
      return toFixedOrDash(flowWaterDistribution.flow_totilizer_x04);
    }
  };

  const getTotalValue = (tab) => {
    if (flowWaterProduction && tab === "tab1") {
      return toFixedOrDash(flowWaterProduction.current_totilizer_x08);
    }
    if (flowWaterDistribution && tab === "tab2") {
      return toFixedOrDash(flowWaterDistribution.current_totilizer_x04);
    }
  };
  const getLabel = () => {
    return selectedFilter === "Day"
      ? "Today"
      : selectedFilter === "Month"
      ? "Month to date"
      : selectedFilter === "Year"
      ? "Year to date"
      : "Week to date";
  };
  const currentValue = getCurrentValue(tab);
  const recentValue = getRecentValue(tab);
  const totalValue = getTotalValue(tab);

  return (
    <div className="flow-page grid grid-cols-1 lg:grid-cols-3 gap-y-5 lg:gap-x-5">
      <div className="col-span-2">
        <BarChart
          setSelectedFilter={(val) => setSelectedFilter(val)}
          setTab={setTab}
          plantId={plantId}
        />
      </div>
      <CardWrapper className="flow-page-stats flow-page-stats-flow">
        <ReportFlowTag
          className="border-bottom"
          title={
            tab === "tab1"
              ? "Current produced water"
              : "Current distributed water"
          }
          number={currentValue || "--"}
          unit={currentValue && currentValue !== "--" ? "l/min" : undefined}
        />
        <ReportFlowTag
          className="border-bottom"
          title={getLabel(selectedFilter)}
          number={recentValue || "--"}
          unit={recentValue && recentValue !== "--" ? "&nbsp;m<sup>3</sup>" : undefined}
        />
        <ReportFlowTag
          title="Total flow value"
          number={totalValue || "--"}
          unit={totalValue && totalValue !== "--" ? "&nbsp;m<sup>3</sup>" : undefined}
        />
      </CardWrapper>
      <div className="col-span-2">
        <FlowTable activeTab={tab} plantId={plantId} />
      </div>
    </div>
  );
}
